import { render, staticRenderFns } from "./Review.vue?vue&type=template&id=36165d2c&scoped=true&"
import script from "./Review.vue?vue&type=script&lang=js&"
export * from "./Review.vue?vue&type=script&lang=js&"
import style0 from "./Review.vue?vue&type=style&index=0&id=36165d2c&prod&scoped=true&lang=css&"
import style1 from "./Review.vue?vue&type=style&index=1&id=36165d2c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36165d2c",
  null
  
)

export default component.exports